export const SIGN_UP_REQUEST = "SIGN_UP_REQUEST";
export const SIGN_UP_SUCCESS = "SIGN_UP_SUCCESS";
export const SIGN_UP_ERROR = "SIGN_UP_ERROR";

export const SIGN_OUT_REQUEST = "SIGN_OUT_REQUEST";
export const SIGN_OUT_SUCCESS = "SIGN_OUT_SUCCESS";
export const SIGN_OUT_ERROR = "SIGN_OUT_ERROR";

export const SEND_PASSWORD_RESET_EMAIL_REQUEST =
  "SEND_PASSWORD_RESET_EMAIL_REQUEST";
export const SEND_PASSWORD_RESET_EMAIL_ERROR =
  "SEND_PASSWORD_RESET_EMAIL_ERROR";
export const SEND_PASSWORD_RESET_EMAIL_SUCCESS =
  "SEND_PASSWORD_RESET_EMAIL_SUCCESS";

export const RESET_AUTH_STATE = "RESET_AUTH_STATE";

export const RESET_STORE_AND_LOG_OUT = "RESET_STORE_AND_LOG_OUT";

export const UPDATE_USER_ACCOUNT_REQUEST = "UPDATE_USER_ACCOUNT_REQUEST";
export const UPDATE_USER_ACCOUNT_SUCCESS = "UPDATE_USER_ACCOUNT_SUCCESS";
export const UPDATE_USER_ACCOUNT_ERROR = "UPDATE_USER_ACCOUNT_ERROR";
export const UPDATE_USER_ACCOUNT_RESET = "UPDATE_USER_ACCOUNT_RESET";

export const RESET_PASSWORD_STATE = "RESET_PASSWORD_STATE";
export const CHANGE_PASSWORD_REQUEST = "CHANGE_PASSWORD_REQUEST";
export const CHANGE_PASSWORD_ERROR = "CHANGE_PASSWORD_ERROR";
export const CHANGE_PASSWORD_SUCCESS = "CHANGE_PASSWORD_SUCCESS";
